// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo-container {
    position: relative;
    margin-top: 20px;
  }
  
  .stadtplan {
    width: 100%;
    height: auto;
  }
  
  .marker {
    position: absolute;
    width: 25px;
    height: 25px;
    transform: translate(-50%, -50%);
  }
  `, "",{"version":3,"sources":["webpack://./src/arbeit/jobsmarkieren/JobsMarkieren.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gCAAgC;EAClC","sourcesContent":[".logo-container {\n    position: relative;\n    margin-top: 20px;\n  }\n  \n  .stadtplan {\n    width: 100%;\n    height: auto;\n  }\n  \n  .marker {\n    position: absolute;\n    width: 25px;\n    height: 25px;\n    transform: translate(-50%, -50%);\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
